/* @flow */

import React from 'react';

import { Route, IndexRoute } from 'react-router';
import { loadRoute, render, ViewerQueries } from 'depop/router';

const prepareParams = (params, {location}) => {
  const {
    q,
  } = location.query;
  return {
    ...params,
    query: q || '',
  };
};

export default (
  <Route path="search">
    <IndexRoute
      getComponent={(location, cb) => loadRoute(import('./views/Search'), cb)}
      queries={ViewerQueries}
      prepareParams={prepareParams}
      render={render} />
  </Route>
);



// WEBPACK FOOTER //
// ../src/client/apps/search/index.js